import { render, staticRenderFns } from "./channelList.vue?vue&type=template&id=12d6c764&scoped=true&"
import script from "./channelList.vue?vue&type=script&lang=js&"
export * from "./channelList.vue?vue&type=script&lang=js&"
import style0 from "./channelList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./channelList.vue?vue&type=style&index=1&id=12d6c764&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d6c764",
  null
  
)

export default component.exports